export default __webpack_public_path__ + "static/share-466f93a34e6bdc0bea168e2e1ff4637f.jpg";